export { PrepareParlorContainer as default } from "containers/FuneralPrepareContainer";
